<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loadingCupones"></loading>
    <b-row class="text-center mt-4">
      <b-col cols="1" md="3">
      </b-col>

      <b-col cols="9" md="6" >
        <b-row class="contenedorTablaSinColor" style="background:white ">
          <b-col cols="10" lg="11" class="pr-0">
            <b-input-group class="pl-3" >
              <b-form-input
                  v-if="filtroSeleccionado === 1"
                  class="input-filter"
                  maxLength="15"
                  v-model="filtro.codigoCupon"
                  type="search"
                  id="filterInput"
                  responsive
                  placeholder="Búsqueda de cupones"
                  @keydown.enter.native="buscarCupones()"
              >
              </b-form-input>
<!--              <b-form-select
                  v-if="filtroSeleccionado === 2"
                  v-model="filtro.idTipoDescuento"
                  :options="opcionesTipoDescuento"
                  class="border-0"
                  value-field="idTipoDescuentoCupon"
                  text-field="descripcion"
                  disabled-field="notEnabled"
              ></b-form-select>
              <b-form-select
                  v-if="filtroSeleccionado === 3"
                  v-model="filtro.idTipoCupon"
                  :options="opcionesTipoCupon"
                  class="border-0"
                  value-field="idTipoCupon"
                  text-field="descripcion"
                  disabled-field="notEnabled"
              ></b-form-select>
              <b-form-select
                  v-if="filtroSeleccionado === 4"
                  v-model="filtro.idEstatusCupon"
                  :options="opcionesTipoEstatusCupon"
                  class="border-0"
                  value-field="idEstatusCupon"
                  text-field="descripcion"
                  disabled-field="notEnabled"
              ></b-form-select>
              <b-input-group-append >
                <b-dropdown
                    class="input-filter"
                    @hide="search.etapaSearch = ''"
                    variant="white"
                    responsive
                >
                  <template #button-content>
                  <span :class="filtroSeleccionado.length > 0 ? 'filtro' : 'filtro-normal'">
                    {{ filtroSeleccionado.length > 0 ? '(' + filtroSeleccionado.length + ') Filtros' : 'Filtros' }}
                  </span>
                  </template>


                  <div class="contenedor-drop">
                    <b-form-group class="m-2" v-slot="{ ariaDescribedby }">
                      <b-form-radio
                          v-for="option in listaFiltro"
                          v-model="filtroSeleccionado"
                          :key="option.idFiltro"
                          :value="option.idFiltro"
                          :aria-describedby="ariaDescribedby"
                          name="flavour-3a"
                          @change="limpiarFiltros"
                      >
                        {{ option.descripcion }}
                      </b-form-radio>
                    </b-form-group>

                  </div>
                </b-dropdown>
              </b-input-group-append>-->
            </b-input-group>
          </b-col>
          <b-col cols="2" lg="1" class="pl-0">
            <b-button
                class="mt-1 pb-1"
                size="sm"
                variant="info"
                :disabled="loading"
                @click="buscarCupones"
                responsive
            >
              <span v-if="!loading"
              >
                <em class="buscar_svg primary sm"></em>
              </span>
              <span v-else><b-spinner small></b-spinner></span>
            </b-button>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="1" class="text-left mt-auto mb-auto">
        <b-button
            variant="primary"
            v-b-tooltip.hover
            title="Alta de Cupones"
            class="paddingbotones botonesAzulFuerte"
            @click="altaCupones"
            responsive
        ><em class="vale_svg icon-boton"></em>
        </b-button>
      </b-col>
    </b-row>


        <b-row >
          <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
            <b-table
                :hover="true"
                :small="true"
                style="font-size: 12px !important; padding: 0.1rem;"
                responsive
                fixed
                :fields="fields"
                :items="items"
                :per-page="registrosPorPagina"
                :current-page="currentPage"
                thead-tr-class="columnasTablaSinColorLetter"
                >

              <template v-slot:cell(Acciones)="row" style="width: 200px">
                <b-button size="sm" variant="warning" class="mr-1 mt-1 marginbotones"
                          v-if="$localStorageService.can('Admin_cupon_editar') && row.item.registroActivo"
                          v-b-tooltip.hover
                          title="Editar"
                          @click="llamarModal(row.item)">
                  <em class="editar_svg sm"></em>
                </b-button>

                <b-button size="sm" variant="outline-success" class="mr-1 mt-1 marginbotones"
                          v-if="!row.item.registroActivo && $localStorageService.can('Admin_cupon_inactivar')"
                          v-b-tooltip.hover
                          title="Activar Cupón"
                          @click="activar(row.item)">
                  <em class="fa fa-undo"></em>
                </b-button>
                <b-button size="sm" variant="danger" class="mr-1 mt-1 marginbotones paddingbotones"
                          v-else
                          v-b-tooltip.hover
                          title="Dar de baja"
                          @click="desactivar(row.item.idCupon)">
                  <em class="eliminar_svg icon-boton"></em>
                </b-button>
              </template>
<!--              <template v-slot:cell(fechaExpedicion)="row">
                {{ row.item.fechaExpedicion | formatoFechaCorta }}
              </template>
              <template v-slot:cell(fechaExpiracion)="row">
                {{ row.item.fechaExpiracion | formatoFechaCorta }}
              </template>-->
            </b-table>
            <div align="center" v-if="loading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b-col v-else>
              <b-alert v-if="items.length === 0" variant="warning" show>No hay datos</b-alert>
            </b-col>
          </b-col>
          <div class="mt-2 w-100 flex justify-content-center align-items-end">
            <b-pagination
                align="center"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="registrosPorPagina"
            ></b-pagination>
          </div>
        </b-row>



    <b-modal
        v-model="mostrarModal"
        size="xl"
        class="redondeo"
        centered
        :no-close-on-backdrop="true"
        hide-footer>

      <template #modal-header="{ ok, close }">
        <div class="seccionTitle mLeft h5">
          <em class=" nuevo_cupon_svg" style=" height: 40px"></em>
          <div class="headerTxt mLeft">{{titulo}}</div>
        </div>
      </template>

      <altaCupones ref="modalModificar" v-if="mostrarModal"
                      @cancelar="mostrarModal=false; modificarFechaExpiracion = false;"
                     :mostrarGuardar="mostrarGuardar"
                     :cuponOriginal="cuponSeleccionado"
                     :modificarFechaExpiracion="modificarFechaExpiracion"
                     @actualizar="buscarCuponesRegistro"/>
    </b-modal>
  </div>
</template>

<script>

import {validationMixin} from "vuelidate";
import altaCupones from "@/views/cupones/altaCupones.vue";


export default {
  name: "listaCupones",
  components: {
    altaCupones,
  },

  mixins: [validationMixin],
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loading: false,
      loadingCupones: false,

      fields: [
        {key: "idCupon", label: "ID cupón", sortable: true},
        {key: "codigo", label: "Código", sortable: true},
        /*{key: "tipoDescuentoCupon", label: "Tipo Descuento", sortable: true},*/
        {key: "motivo", label: "Motivo Cupón", sortable: true},
        {key: "tipoCupon", label: "Tipo Cupón", sortable: true},
        {key: "numeroRedenciones", label: "Número Redenciones", sortable: true},
       /* {key: "cantidadDescuento", label: "Cantidad Descuento", sortable: true},*/
        {key: "estatusCupon", label: "Estatus Cupón", sortable: true},
        /*{key: "fechaExpedicion", label: "Fecha Expedición ", sortable: true},
        {key: "fechaExpiracion", label: "Fecha Expiración", sortable: true},*/
        "Acciones",
      ],

      currentPage: 1,
      items: [],
      registrosPorPagina:10,

      mostrarModal: false,
      titulo: "",
      cuponSeleccionado: {},
      filterTratamientos: null,

      search: {
        etapaSearch: "",
        clasificacionSearch: "",
      },
      listaFiltro: [
        { idFiltro: 1, descripcion: "Código" },
        { idFiltro: 2, descripcion: "Tipo Descuento" },
        { idFiltro: 3, descripcion: "Tipo Cupón" },
        { idFiltro: 4, descripcion: "Estatus Cupón" },
      ],

      filtro:{
        codigoCupon: '',
        idTipoDescuento: null,
        idTipoCupon: null,
        idEstatusCupon: null
      },
      mostrarGuardar: false,
      filtroSeleccionado: 1,
      opcionesTipoDescuento: [],
      opcionesTipoCupon: [],
      opcionesTipoEstatusCupon: [],
      modificarFechaExpiracion: false
    };
  },
  mounted() {
    this.buscarCupones();
    this.catalogos();
  },

  methods: {
    altaCupones() {
      this.mostrarModal = true;
      this.titulo = "Nuevo Cupón";
      this.cuponSeleccionado = {};
      this.mostrarGuardar = true;
    },
    buscarCuponesRegistro(filtro) {
      this.modificarFechaExpiracion = false;
      this.filtroSeleccionado = 1;
      this.filtro.codigoCupon = filtro;
      this.mostrarModal = false;
      this.buscarCupones();
    },
    limpiarFiltros() {
      this.filtro = {
        codigoCupon: '',
        idTipoDescuento: null,
        idTipoCupon: null,
        idEstatusCupon: null
      }
    },
    buscarCupones() {
      this.currentPage = 1;
      this.loading = true;
      this.items = [];
      this.$http
          .post(this.$api + "cupon/obtenerCupones",this.filtro)
          .then((response) => {
            this.items = response.data.data;
          }).finally(() => {
        this.loading = false;
      });
    },
    llamarModal(item) {
      this.cuponSeleccionado = item;
      this.mostrarGuardar = false;
      this.mostrarModal = true;
      this.titulo = "Modificar cupón";
    },
    desactivar(idCupon) {
      const mensaje = '¿Está seguro de desactivar el cupón?';

      this.$swal.fire({
        icon: "warning",
        text: mensaje,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,

        preConfirm: () => {
          this.loading = true;
          this.$http
              .post(this.$api + "cupon/activarDesactivarCupon", idCupon)
              .then((response) => {
                if (response.data.data) {
                  this.buscarCupones();
                  this.$swal.fire({
                    position: "center",
                    icon: "info",
                    title: "Aviso",
                    text:"Se desactivó el cupón ",
                    showConfirmButton: false,
                    timer: 3500,
                  });
                }
              });
        },
      });

    },
    activar(item) {
      const fechaCupon = new Date(item.fechaExpiracion).addHours(6);
      const fechaHoy = new Date();
      fechaHoy.setDate(fechaHoy.getDate());
      fechaHoy.setHours(0, 0, 0, 0);

      if (fechaCupon < fechaHoy) {
        this.$swal.fire({
          text: 'Antes de activar, asegúrate de actualizar la fecha de expiración.',
          icon: "info",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.llamarModal(item)
            this.modificarFechaExpiracion = true;
          },
        });

        return;
      }

      this.$swal.fire({
        text: '¿Desea activar el cupón?',
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,

        preConfirm: () => {
          this.loading = true;
          this.$http
              .post(this.$api + "cupon/activarDesactivarCupon", item.idCupon)
              .then((response) => {
                if (response.data.data) {
                  this.buscarCupones();
                  this.$swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Se activo el cupón ",
                    showConfirmButton: false,
                    timer: 3500,
                  });
                }
              });
        },
      });

    },



    catalogos() {
      this.$http.get(this.$api + "catalogos/obtenerTiposDescuentos").then(response => {
            if (response.data.data) {
              response.data.data.unshift({idTipoDescuentoCupon: null, descripcion: "Seleccione descuento"})
              this.opcionesTipoDescuento = response.data.data;
            }
          }
      )

      this.$http.get(this.$api + "catalogos/obtenerTiposCupones").then(response => {
            if (response.data.data) {
              response.data.data.unshift({idTipoCupon: null, descripcion: "Seleccione cupón"})
              this.opcionesTipoCupon = response.data.data
            }
          }
      )

      this.$http.get(this.$api + "catalogos/obtenerEstatusCupon").then(response => {
            if (response.data.data) {
              response.data.data.unshift({idEstatusCupon: null, descripcion: "Seleccione estatus"})
              this.opcionesTipoEstatusCupon = response.data.data
            }
          }
      )
    }
  },
  computed: {
    rows() {
      return this.items.length;
    },

  },
  watch: {
    filtro() {
      this.$emit("actualizarFiltro", this.filtro);
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }

};
</script>

<style scoped>

.input-filter,
.input-filter:focus {
  background: transparent;
  border: 0px;
  box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
}

.botonesAzulFuerte {
  border-radius: 10rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-left: 5%;
}
.icon-boton-agenda {
  filter: invert(18%) sepia(86%) saturate(1218%) hue-rotate(179deg) brightness(93%) contrast(90%);
  height: 20px;
  display: block;
}
.redondeo{
  border-radius: 10px !important;
}

.botonesGrisFuerte {
  border-radius: 10rem;
  color: #fff;
  margin-left: 5%;
}
.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}
.paddingbotones {
  padding: 5px;
}

.marginbotones{
  border-radius:20px;
}

.icon-redondo{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.botonConfigEstilo {
  padding-bottom: 4px;
  padding-top: 5px;
  padding-left: 6px;
  padding-right: 7px;
}
</style>
